/**
 * In-memory-only access token store (QA WEB-003, Tony ruling 2026-09-18).
 *
 * The JWT access token is NEVER written to localStorage/sessionStorage — it
 * lives only as a module-level variable here, for the lifetime of this
 * browser window. Every window (main tab, a full reload, or a popout — a
 * popout is a genuinely separate JS realm, it does NOT share this module's
 * memory even though it shares localStorage) boots with `null` and re-mints
 * a token via `refreshAccessToken()` in `api.ts`, which talks to the
 * httpOnly `jm_refresh` cookie the backend sets on login/refresh.
 *
 * Split into its own module (rather than living in api.ts) so files that
 * only need to READ the current token — error-reporter.ts, jwt-claims.ts,
 * DevAuthInspector.tsx — can do so without a circular import back through
 * api.ts (which itself imports error-reporter.ts).
 */
let _accessToken: string | null = null

/** Current in-memory access token for this window, or null if not (yet) minted. */
export function getAccessToken(): string | null {
  return _accessToken
}

/** Set (or clear, with null) the in-memory access token for this window. */
export function setAccessToken(token: string | null): void {
  _accessToken = token
}
